import {
  Box,
  Button,
  Divider,
  List,
  ListItemButton,
  ListItemText,
  Typography,
} from "@mui/material";
import { GetPortalsNavigations } from "../../services/portalsService";
import { useEffect, useState } from "react";
import { useDispatch } from "react-redux";
import authService from "../../services/authService";
import { useHistory } from "react-router-dom/cjs/react-router-dom";
import { ReactComponent as Logo } from "./../../logo.svg";

export default function PortalSelection() {
  const dispatch = useDispatch();
  const history = useHistory();
  const [portals, setPortals] = useState(undefined);

  useEffect(() => {
    GetPortalsNavigations().then((routes) => {
      setPortals(routes);
    });
  }, []);

  const logout = () => {
    authService.logout();
    dispatch({ type: "USER_LOGGED_OUT" });
  };
  const gotoPortal = (route) => {
    history.push(route);
  };
  const gotoNewProposal = () => {
    history.push("/newproposal");
  };
  return (
    <Box
      height="100vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      flexDirection="column"
      
    >
      <Box marginBottom="1.5rem">
        <Logo />
      </Box>
      <Typography fontSize="2.5rem">Gif Portal</Typography>
      <Typography fontSize="1.5rem">Please choose from below:</Typography>
      <Box marginTop="3rem">
      <List
        component="nav"
        sx={{
          minWidth: "350px",
        }}
      >
        {portals &&
          portals.map((p, i) => (
            <Box key={i}>
              <ListItemButton onClick={() => gotoPortal(p.route)}>
                <ListItemText
                  primary={p.name}
                  secondary={p.secondery}
                  primaryTypographyProps={{ fontSize: "1.5rem", color: "red" }}
                  secondaryTypographyProps={{ fontSize: "1rem" }}
                />
              </ListItemButton>
              <Divider variant="middle" />
            </Box>
          ))}
      </List>
      <Box display="flex"  justifyContent="space-between" fontSize="1.5rem">
            <Button size="large" onClick={logout}>Logout</Button>
            <Button size="large" onClick={gotoNewProposal}>Create New Pre-Proposal</Button>
          </Box>
    </Box>
    </Box>
  );
}
